export default {
  "business.displayExclude": "無料/調整動員を除外して表示",
  "business.freeMobilization": "無料動員",
  "business.coordMobilization": "調整動員",
  "business.businessDailyReport": "営業日報（概要）",
  "business.date": "年月",
  "business.balance": "売上/現金収支精算表",
  "business.refund": "レジ締め済取引の払戻・修正 / 過去営業日取引の追加",
  "business.accounting": "会計伝票（簡易形式）",
};